import React, { useState, useEffect, useContext } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { withStyles } from '@material-ui/core/styles';

import {
  Box,
  Button,
  Container,
  Link,
  Typography,
  makeStyles,
  TextField,
  Grid,
  Icon,
  colors,
  Checkbox,
} from '@material-ui/core';

import Page from 'src/components/Page';
import Alerts from '../../../utils/alerts';
import api from '../../../services/api'

import { Context } from '../../../services/context';

import { BsCheck2Circle } from "react-icons/bs";
import { BsXCircle } from "react-icons/bs";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    height: 45,
    width: 45
  }
}));

var defaultItem = {
  mac: '',
  device: '',
  hardware: '',
  loginadm: '',
  passwordadm: '',
  terms: false
}

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.indigo[800],
    '&$checked': {
      color: colors.indigo[900],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const Activation = () => {

  const classes = useStyles();

  const { handleLogout } = useContext(Context);

  const [item, setItem] = useState(defaultItem);
  const [user, setUser] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});

  const [state, setState] = useState({
    loaded: false,
    logged: false,
    autenticated: false
  })

  var query = useParams();

  const refreshItems = async () => {
    localStorage.setItem('authenticateDevice', query.device);
    await api.get('/activations/device/' + query.device, {}, {}).then((response) => {
      var item = {
        mac: (response.data.device) ? response.data.device.mac : '',
        device: (response.data.device) ? response.data.device.description : '',
        hardware: (response.data.hardware) ? response.data.hardware.name : '',
        loginadm: '',
        passwordadm: ''
      };
      setItem(item);
      setState({
        loaded: true,
        logged: false,
        autenticated: false
      });
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const requestUser = (value, values) => {
    values.loginadm = value;
    if (value != '') {
      api.get('/activations/user/' + value, {}, {}).then((response) => {
        if (response.data.error) {
          setState({ ...state, logged: false, autenticated: false });
          setUser(null);
          setMessage(response.data);
          setOpenAlert(true);
        } else {
          if (response.data.user) {
            setUser(response.data.user);
            setState({ ...state, logged: true, autenticated: false });
          }
        }
      }).catch((error) => {
        console.error(error);
        setState({ ...state, logged: false, autenticated: false });
        setUser(null);
        setMessage({ error: true, info: true, message: error.message });
        setOpenAlert(true);
      })
    }
  }

  const requestPermission = async (value, values) => {
    if (value != '' && state.logged) {
      if (user && user.password == values.passwordadm) {
        if (user.profile == 'ENG' || user.profile == 'ADM') {
          setState({ ...state, autenticated: true });
        } else {
          setState({ ...state, autenticated: false });
          setMessage({ error: true, info: true, message: "Usuário não tem autorização para ativar equipamento" });
          setOpenAlert(true);
        }
      } else {
        setState({ ...state, autenticated: false });
        setMessage({ error: true, info: true, message: "Usuário não tem autorização para ativar equipamento" });
        setOpenAlert(true);
      }
    }
  }

  const updateValues = (values) => {
    api.post('/activations/activate', {
      "company": user.company,
      "user": user._id,
      "device": values.mac
    }, {}).then((response) => {
      setMessage(response.data);
      setOpenAlert(true);
      localStorage.removeItem('authenticateDevice');
    }).catch((error) => {
      console.error(error);
      setState({ ...state, logged: false, autenticated: false });
      setUser(null);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Ativação"
    >
      <Container maxWidth={false}>

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        {(state.loaded) ?
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="center"
          >
            <Container maxWidth="sm">
              <Formik

                initialValues={item}

                validationSchema={Yup.object().shape({
                  loginadm: Yup.string().required('Informar o Usuário é obrigatório.'),
                  passwordadm: Yup.string().required('Informar a Senha é obrigatório.'),
                  device: Yup.string().required('Nenhum Informação para criar o equipamento foi encontrada.'),
                  //hardware: Yup.string().required('Nenhum Parâmetro de Hardware foi encontrado.'),
                  mac: Yup.string().required('Nehum Dispositivo foi encontrado para ativar.')
                })}

                onSubmit={async (values, formik) => {
                  updateValues(values);
                  formik.setSubmitting(false);
                }}

              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  touched,
                  values
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box mb={3}>
                      <Typography
                        color="textPrimary"
                        variant="h2"
                      >
                        Registrar Equipamento
                      </Typography>
                      <Typography
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                      >
                        Acessar o SIMM
                      </Typography>
                    </Box>


                    <Grid
                      container
                      justifyContent='flex-start'
                      alignItems='center'
                      spacing={2}
                    >

                      <Grid
                        item
                        md={10}
                        xs={10}>
                        <TextField
                          error={Boolean(touched.mac && errors.mac)}
                          fullWidth
                          helperText={touched.mac && errors.mac}
                          label="Dispositivo (MAC)"
                          margin="none"
                          name="mac"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.mac}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid
                        item
                        md={1}
                        xs={1}>
                        {(values.mac) ?
                          <Icon className={classes.avatar} component={BsCheck2Circle} style={{ color: colors.green[800] }} ></Icon>
                          :
                          <Icon className={classes.avatar} component={BsXCircle} style={{ color: colors.red[800] }} ></Icon>
                        }
                      </Grid>


                      <Grid
                        item
                        md={10}
                        xs={10}>
                        <TextField
                          error={Boolean(touched.hardware && errors.hardware)}
                          fullWidth
                          helperText={touched.hardware && errors.hardware}
                          label="Descrição"
                          minRows={2}
                          multiline
                          margin="none"
                          name="hardware"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.hardware}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid
                        item
                        md={1}
                        xs={1}>
                        {(values.hardware) ?
                          <Icon className={classes.avatar} component={BsCheck2Circle} style={{ color: colors.green[800] }} ></Icon>
                          :
                          <Icon className={classes.avatar} component={BsXCircle} style={{ color: colors.red[800] }} ></Icon>
                        }
                      </Grid>

                      <Grid
                        item
                        md={10}
                        xs={10}>

                        <TextField
                          error={Boolean(touched.device && errors.device)}
                          fullWidth
                          helperText={touched.device && errors.device}
                          label="Nome"
                          minRows={2}
                          multiline
                          margin="none"
                          name="device"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.device}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ readOnly: true }}
                        />

                      </Grid>

                      <Grid
                        item
                        md={1}
                        xs={1}>
                        {(values.device) ?
                          <Icon className={classes.avatar} component={BsCheck2Circle} style={{ color: colors.green[800] }} ></Icon>
                          :
                          <Icon className={classes.avatar} component={BsXCircle} style={{ color: colors.red[800] }} ></Icon>
                        }
                      </Grid>

                      <Grid
                        item
                        md={10}
                        xs={10}>

                        <TextField
                          error={Boolean(touched.loginadm && errors.loginadm)}
                          fullWidth
                          helperText={touched.loginadm && errors.loginadm}
                          label="Usuário"
                          margin="none"
                          id="loginadm"
                          name="loginadm"
                          onBlur={e => {
                            requestUser(e.currentTarget.value, values);
                            handleBlur(e);
                          }}
                          onChange={handleChange}
                          value={values.loginadm}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>

                      <Grid
                        item
                        md={1}
                        xs={1}>
                        {(state.logged) ?
                          <Icon className={classes.avatar} component={BsCheck2Circle} style={{ color: colors.green[800] }} ></Icon>
                          :
                          <Icon className={classes.avatar} component={BsXCircle} style={{ color: colors.red[800] }} ></Icon>
                        }
                      </Grid>

                      <Grid
                        item
                        md={10}
                        xs={10}>

                        <TextField
                          error={Boolean(touched.passwordadm && errors.passwordadm)}
                          fullWidth
                          helperText={touched.passwordadm && errors.passwordadm}
                          label="Senha"
                          margin="none"
                          id="passwordadm"
                          name="passwordadm"
                          onBlur={e => {
                            requestPermission(e.currentTarget.value, values);
                          }}
                          onChange={handleChange}
                          type="password"
                          value={values.passwordadm}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />

                      </Grid>

                      <Grid
                        item
                        md={1}
                        xs={1}>
                        {(state.autenticated) ?
                          <Icon className={classes.avatar} component={BsCheck2Circle} style={{ color: colors.green[800] }} ></Icon>
                          :
                          <Icon className={classes.avatar} component={BsXCircle} style={{ color: colors.red[800] }} ></Icon>
                        }
                      </Grid>

                      <Grid
                        item
                        md={6}
                        xs={6}>

                        <Grid
                          container
                          alignItems='baseline'>

                          <Grid
                            item>
                            <ColorCheckbox
                              required
                              checked={values.terms}
                              onBlur={handleBlur}
                              onChange={handleChange} />
                          </Grid>

                          <Grid
                            item>
                            <Typography variant="h6">
                              Aceito termos e condições
                            </Typography>

                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        md={10}
                        xs={10}>

                        <Button
                          color="secondary"
                          fullWidth
                          disabled={isSubmitting || !state.logged || !state.autenticated}
                          size="small"
                          type="submit"
                          variant="contained"
                        >
                          Ativar
                        </Button>
                      </Grid>

                    </Grid>

                    <Grid
                      item
                      md={10}
                      xs={10}>

                      <Typography
                        color="textSecondary"
                        variant="body1"
                      >
                        Já tem acesso?
                        {' '}
                        <Link
                          component={RouterLink}
                          to="/login"
                          onClick={handleLogout}
                          variant="h6"
                        >
                          Entrar com usuário e senha
                        </Link>
                      </Typography>

                    </Grid>

                  </form>
                )}
              </Formik>
            </Container>
          </Box>
          :
          ''}
      </Container>

    </Page>
  );
};

export default Activation;
